import React from 'react';

interface IconProps {
  fill: string;
  height: string | number;
  width: string | number;
}

function LoanIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 73 53">
      <path
        fill={fill}
        d="M59.727 33.125v-26.5C59.727 2.981 56.741 0 53.091 0H6.636C2.986 0 0 2.981 0 6.625v26.5c0 3.644 2.986 6.625 6.636 6.625h46.455c3.65 0 6.636-2.981 6.636-6.625zm-29.863-3.313c-5.509 0-9.955-4.438-9.955-9.937s4.447-9.938 9.955-9.938 9.954 4.44 9.954 9.938c0 5.499-4.446 9.938-9.954 9.938zM73 9.938v36.438C73 50.019 70.014 53 66.364 53H9.954v-6.625h56.41V9.937H73z"
      ></path>
    </svg>
  );
}

export default LoanIcon;
